import { ProductGroups } from "../../../../../modules/merchant/admin/products/productsTypes"

export const filterShops = (
    isFavorite: boolean,
    searchRegex: RegExp | undefined,
    productGroups?: ProductGroups[],
): ProductGroups[] | undefined => {
    if (!productGroups || (!isFavorite && !searchRegex)) return productGroups

    const filteredGroups: ProductGroups[] = productGroups
        .map((group) => {
            const filteredProducts = group.products.filter((product) => {
                const isProductFavorite = isFavorite ? !!product?.userDetails?.isFavorite : true
                const passesSearch = searchRegex ? searchRegex.test(product.name) : true
                return isProductFavorite && passesSearch
            })

            if (filteredProducts.length > 0) {
                return {
                    ...group,
                    products: filteredProducts,
                }
            }

            return null
        })
        .filter((group): group is ProductGroups => group !== null)

    if (filteredGroups.length === 0) return undefined

    return filteredGroups
}
